import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
const tiers = [{
  name: 'Acolyte',
  price: 'Free',
  description: 'Begin your journey',
  features: ['Community access', 'Obsidian Archive (limited)', 'Public profile', 'Monthly gatherings'],
  cta: 'Join as Acolyte',
  highlight: false
}, {
  name: 'Nightwarden',
  price: '€9',
  period: '/month',
  description: 'Deepen your craft',
  features: ['Everything in Acolyte', 'Full Archive access', 'Thornmarket seller account', 'Vesper Circle rooms (3)', 'Priority curation'],
  cta: 'Become Nightwarden',
  highlight: true
}, {
  name: 'Archon',
  price: '€19',
  period: '/month',
  description: 'Command the shadows',
  features: ['Everything in Nightwarden', 'Unlimited Vesper Circles', 'Featured creator spotlight', 'Custom storefront', 'Grimoire masterclasses', 'Direct patron channel'],
  cta: 'Ascend to Archon',
  highlight: false
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-obsidian relative" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="text-center mb-16" data-id="element-111">
          <h2 className="font-heading text-4xl md:text-5xl text-parchment mb-6" data-id="element-112">
            Choose Your Covenant
          </h2>
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-crimson to-transparent mx-auto" data-id="element-113" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-114">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className={`relative flex flex-col p-8 border ${tier.highlight ? 'bg-charcoal border-amber-glow/50 shadow-[0_0_30px_rgba(212,165,116,0.1)] scale-105 z-10' : 'bg-charcoal/50 border-white/5 hover:border-white/10'} transition-all duration-300`} data-id="element-115">
              {tier.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-glow text-obsidian px-4 py-1 text-xs font-heading font-bold uppercase tracking-widest" data-id="element-116">
                  Most Popular
                </div>}

              <div className="mb-8 text-center" data-id="element-117">
                <h3 className={`font-heading text-xl font-bold mb-2 ${tier.highlight ? 'text-amber-glow' : 'text-parchment'}`} data-id="element-118">
                  {tier.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-119">
                  <span className="font-heading text-4xl font-bold text-parchment" data-id="element-120">
                    {tier.price}
                  </span>
                  {tier.period && <span className="font-body text-bone/60" data-id="element-121">
                      {tier.period}
                    </span>}
                </div>
                <p className="font-body text-bone/60 italic" data-id="element-122">
                  {tier.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-123">
                {tier.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-bone/80 font-body" data-id="element-124">
                    <Check className={`w-5 h-5 flex-shrink-0 ${tier.highlight ? 'text-amber-glow' : 'text-bone/40'}`} data-id="element-125" />
                    <span data-id="element-126">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={tier.highlight ? 'primary' : 'secondary'} className="w-full" data-id="element-127">
                {tier.cta}
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}